import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://happyu.onrender.com/login", {
        email,
        password,
      });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("tokenUser", res.data.user.username);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      navigate("/");
    } catch (err) {
      setError("Invalid email or password");
    }
  };

  const closeModal = () => setError("");

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-lightCream via-white to-darkCream relative">
      {/* Error Modal */}
      {error && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div
            className="fixed inset-0 bg-gray-700 bg-opacity-60"
            onClick={closeModal}
          ></div>
          <div className="bg-white rounded-xl shadow-2xl p-6 z-10 w-[90%] max-w-sm text-center">
            <div className="flex flex-col items-center">
              <div className="bg-red-100 rounded-full p-3 mb-3">
                <svg
                  className="h-8 w-8 text-red-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1-8V7a1 1 0 112 0v3a1 1 0 01-2 0zm0 4a1 1 0 112 0 1 1 0 01-2 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <h2 className="text-lg font-semibold text-gray-800">Error</h2>
              <p className="text-gray-500 mt-1">{error}</p>
              <button
                onClick={closeModal}
                className="mt-4 px-6 py-2 bg-red-600 text-white rounded-full hover:bg-red-700 transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Login Card */}
      <div className="bg-white/80 backdrop-blur-md shadow-2xl rounded-2xl p-10 w-[90%] max-w-md border border-darkCream">
        <h2 className="text-3xl font-bold text-center text-black mb-6">
          Welcome Back 👋
        </h2>
        <p className="text-center text-gray-500 mb-8 text-sm">
          Sign in to continue to your account
        </p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="relative">
            <input
              type="email"
              id="email"
              className="peer w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-darkCream text-gray-800 placeholder-transparent"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label
              htmlFor="email"
              className="absolute left-3 -top-2.5 bg-white px-1 text-xs text-gray-600 transition-all peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-3 peer-placeholder-shown:text-sm peer-focus:-top-2.5 peer-focus:text-xs peer-focus:text-darkCream"
            >
              Email Address
            </label>
          </div>

          <div className="relative">
            <input
              type="password"
              id="password"
              className="peer w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-darkCream text-gray-800 placeholder-transparent"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label
              htmlFor="password"
              className="absolute left-3 -top-2.5 bg-white px-1 text-xs text-gray-600 transition-all peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-3 peer-placeholder-shown:text-sm peer-focus:-top-2.5 peer-focus:text-xs peer-focus:text-darkCream"
            >
              Password
            </label>
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-darkCream text-gray-800 rounded-lg font-semibold hover:bg-lightCream transition border border-lightCream"
          >
            Sign In
          </button>

          <div className="flex justify-between items-center text-sm mt-3">
            <a
              href="/signup"
              className="text-lightLeafGreen hover:underline font-medium"
            >
              Create an Account
            </a>
            <a href="/" className="text-gray-600 hover:underline">
              Go Back Home
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
